//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    getGroupTradeInfo,
    wxConfigAjax
} from '../../../../api';
import MHeader from '../../../Header/Header.vue';
export default {
    data() {
        return {
            data: null
        }
    },
    components: {
        MHeader
    },
    created() {
        this.$store.commit('showIsLoading');
        getGroupTradeInfo(`tid=${this.$route.params.tid}`).then(res => {
            if (res.data.error_code) {
                this.$router.go(-1);
                console.error(res);
                return;
            };
            this.data = res.data.data;
            if (this.data.grouplog_info) {
                if (this.data.grouplog_info.groupbuyEx == 0 && this.data.grouplog_info.isFullGroup == 0) { // 还未满团
                    wxConfigAjax({
                        title: `【拼团活动】` + this.data.groupbuy_info.groupbuy_title,
                        desc: '【拼团活动】' + this.data.groupbuy_info.groupbuy_title,
                        url: ``,
                        imgUrl: this.data.groupbuy_info.groupbuy_image
                    })
                } else {
                    wxConfigAjax({
                        title: `【快买酒】` + this.data.groupbuy_info.groupbuy_title,
                        desc: '【快买酒】' + this.data.groupbuy_info.groupbuy_title,
                        url: `Detail/${this.data.groupbuy_info.item_info.item_id}`,
                        imgUrl: this.data.groupbuy_info.groupbuy_image
                    })
                }
            };
        });

    },
    computed: {
        payType() {
            switch (this.data.pay_app_id) {
                case "wxpayapp":
                    return "微信";
                    break;
                case "wxpayjsapi":
                    return "微信";
                    break;
                case "alipayapp":
                    return "支付宝";
                    break;
                default:
                    return "在线支付";
                    break;
            }
            return ''
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/spellGroup/OrderDetail/OrderDetail.vue